export default "__VITE_ASSET__qIqjNR4W__"